<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="8"
        offset-md="2"
        lg="6"
        offset-lg="3"
        xl="4"
        offset-xl="4"
        class="mb-3"
      >
        <template v-if="reportRawData != null">
          <v-row>
            <v-col>
              <v-sheet>
                <v-toolbar flat>
                  <v-toolbar-title
                    class="title text-uppercase"
                    :style="{
                      margin: $vuetify.breakpoint.lgAndUp ? '' : 'auto',
                    }"
                    >KCT - Transformative Personality</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                  <v-btn icon @click="closeWebView">
                    <v-icon small>far fa-times</v-icon>
                  </v-btn>
                </v-toolbar>
              </v-sheet>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="customHeader rounded">
                <div class="title mx-2">ผลสรุป</div>
              </div>
              <div class="customContent" align="center">
                <apexchart
                  type="radar"
                  :options="options"
                  :series="series"
                  :height="$vuetify.breakpoint.mdAndUp ? 'auto' : 270"
                ></apexchart>
              </div>
            </v-col>
          </v-row>

          <div style="position: relative; top: -50px">
            <v-row>
              <v-col>
                <div class="customContent" align="center" style="width: 100%">
                  <div>
                    <div
                      style="color: #224f84; font-size: 20px; font-weight: bold"
                      class="mb-4"
                    >
                      ผลการประเมินจัดอยู่ในกลุ่ม <br />
                      {{ reportRawData.myGroup.key }}
                    </div>
                    <div>
                      <template
                        v-if="typeof reportRawData.myGroup.desc == 'string'"
                      >
                        {{ reportRawData.myGroup.desc }}
                      </template>
                      <template v-else>
                        <p
                          class="mb-3"
                          v-for="(paragraph, idx) of reportRawData.myGroup.desc"
                          :key="`paragraph_${idx}`"
                        >
                          {{ paragraph }}
                        </p>
                      </template>
                    </div>
                  </div>
                  <v-divider class="my-4"></v-divider>
                  <div
                    style="color: #224f84; font-size: 20px; font-weight: bold"
                    class="pb-4"
                  >
                    การฝึกอบรมที่ต้องการเป็นพิเศษ
                  </div>
                  <p>
                    {{ reportRawData.myPattern.desc }}
                  </p>
                </div>

                <div class="text-center mt-4">
                  <v-btn
                    large
                    color="primary"
                    depressed
                    @click="startNewEvalSession"
                    >ทำแบบสำรวจใหม่</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- <v-row no-gutters class="mt-8">
            <v-col cols="12">
              <div class="customHeader rounded mb-4">
                <div class="title mx-2">คอร์สแนะนำ</div>
              </div>
            </v-col>
            <v-col cols="12">
              <course-renderer
                :courses="courses"
                :items-per-page="itemsPerPage"
                :show-loader="courseLoader"
                :page.sync="currentPage"
              ></course-renderer>
            </v-col>
          </v-row> -->
        </template>
        <template v-else>
          <v-skeleton-loader
            type="card-avatar, article, article"
          ></v-skeleton-loader>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EventBus from "../plugins/event-bus";
import sessionHelper from "../services/evaluateSession";
// import courseService from "../services/courseService";
import reportService from "../services/evalReport";
// import CourseRenderer from "../components/CourseRenderer";

export default {
  // components: {
  //   CourseRenderer,
  // },
  computed: {
    itemsPerPage() {
      if (this.$vuetify.breakpoint.mdOnly) {
        return 5;
      } else if (this.$vuetify.breakpoint.lgAndUp) {
        return 6;
      }
      return 3;
    },
    formId() {
      return sessionStorage.getItem("course");
    },
  },
  data: () => ({
    courses: [],
    courseLoader: false,
    currentPage: 1,
    options: {
      fill: {
        opacity: 0.5,
        colors: ["#BBDEFB"],
      },
      plotOptions: {
        radar: {
          size: 120,
          polygons: {
            strokeColors: "#e9e9e9",
            fill: {
              colors: ["#f8f8f8", "#fff"],
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 960,
          options: {
            plotOptions: {
              radar: {
                size: 60,
              },
            },
          },
        },
      ],
      markers: {
        size: 0,
        strokeColor: "#BBDEFB",
        strokeWidth: 2,
      },
      tooltip: {
        enabled: false,
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return `${val.toFixed(1)}%`;
        },
      },
      labels: [],
      xaxis: {
        categories: [
          "Creativity",
          ["Interdependent", "Collabolative", "Mindset"],
          "Handle Pressure",
          ["Self Leading", "/Self Motivation"],
        ],
        labels: {
          style: {
            fontSize: "11px",
          },
        },
      },
      yaxis: {
        show: false,
        tickAmount: 4,
        max: 100,
        min: 0,
        labels: {
          formatter: function (val, i) {
            return `${val}%`;
          },
        },
      },
      legend: {
        show: false,
        height: 0,
        width: 0,
      },
    },
    series: [
      {
        name: "Real Score",
        data: [],
      },
    ],
    reportRawData: null,
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      EventBus.$emit("overlay", true);
      this.getReport();
    },
    updateChartData(data) {
      // update series & labels
      let seriesData = [];
      let labels = [];
      for (const skill of data.skills) {
        labels.push(skill.name);
        seriesData.push(skill.percentage);
      }

      // find max value
      // const maxScoreSkill = data.summary.skills.reduce(function (
      //   prev,
      //   current
      // ) {
      //   return prev.total > current.total ? prev : current;
      // });

      this.options = {
        ...this.options,
        labels: labels,
        yaxis: {
          ...this.options.yaxis,
          // max: maxScoreSkill.total + 1,
        },
      };
      // seriesData.push(4);
      // seriesData.push(5);
      this.series = [
        {
          name: "Real Score",
          data: seriesData,
        },
      ];
    },
    getReport() {
      reportService
        .getOverviewScore(this.formId, "identity")
        .then((resp) => {
          this.updateChartData(resp.data);
          this.reportRawData = resp.data;
          EventBus.$emit("overlay", false);
          this.courseLoader = true;
          // return courseService.getRecommend();
        })
        .catch((err) => {
          EventBus.$emit("overlay", false);
        })
        .finally(() => {
          this.courseLoader = false;
        });

      // .then((resp) => {
      //   this.courses = resp.data;
      // })
    },
    startNewEvalSession() {
      EventBus.$emit("overlay", true);

      let data = {
        token: sessionStorage.getItem("token") || null,
        course: sessionStorage.getItem("course") || null,
        numStamp: sessionStorage.getItem("numStamp") || 0,
      };
      sessionHelper
        .newSession(data)
        .then((resp) => {
          sessionStorage.setItem("evalId", resp.data);
          this.$router.replace({
            name: "evaluate",
          });
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            if (err.response.data.code == "redirect") {
              // this.$router.replace(err.response.data.message);
            }
          }
        })
        .finally(() => {
          EventBus.$emit("overlay", false);
        });
    },
    closeWebView() {
      EventBus.$emit("closeWebView");
    },
  },
};
</script>

<style scoped>
.customHeader {
  background-color: #e2e8ee;
  padding: 8px;
  color: #506883;
}
.customContent {
  background-color: #ffffff;
  padding: 8px;
  font-size: 15px;
  color: #828282;
}

.customCard {
  background-color: #ffffff;
  padding: 8px;
  border-style: solid;
  border-width: 1px;
  border-radius: 4px;
  border-color: #dcdcdc;
}

.centerContainer {
  position: relative;
}

.center-vertically {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.center-vertical-horizonrally {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.course-catagory {
  color: #224f84;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  padding-bottom: 5px;
}

.course-title {
  color: #000000;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
}
</style>